import React from 'react';
import ReactPlayer from 'react-player';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElementNew';

export default class CmsElementVideo extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  render() {
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const wrapperClass = 'ms-video-wrapper ms-video-wrapper-' + this.getParamValue('videoAspectRatio', '16-9') + ' ';
    const videoUrl = this.getParamValue('videoUrl');
    const playing = this.getParamValue('videoAutoplay', 'no') === 'yes';

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={wrapperClass + shownClass + this.getResponsiveClasses() + this.getCssClasses()}
        style={{ ...this.getBackgroundStyle() }}
      >
        {this.getElementStyle()}

        {shown ? (
          <ReactPlayer
            url={videoUrl}
            controls
            width="100%"
            height="100%"
            playing={playing}
            className="ms-video-player-content"
          />
        ) : (
          <div />
        )}

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementVideo.defaultProps = {
  index: '0',
};
